var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnyReactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.28 108.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4caf50;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.24px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #70bf73;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.14,18.09c19.89,0,36.06,16.17,36.06,36.05s-16.17,36.06-36.06,36.06-36.05-16.17-36.05-36.06S34.26,18.09,54.14,18.09ZM78.81,51.95c0-.5-.31-.96-.77-1.15-.38-.15-9.54-3.78-23.9-3.78s-23.51,3.63-23.89,3.78c-.47.19-.77.65-.77,1.15,0,5.74,2.3,10.91,6.14,14.81,4.49,4.56,11.07,7.39,18.52,7.39s14.03-2.83,18.52-7.39c3.84-3.9,6.15-9.06,6.15-14.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.03,66.73c-.15.15-.31.29-.47.43-.23.21-.47.41-.71.61-.28.24-.57.47-.87.69-4.18,3.12-9.64,5-15.84,5-7.01,0-13.08-2.4-17.41-6.3-.16-.14-.32-.28-.47-.43,4.82-4.33,11.05-6.95,17.88-6.95s13.07,2.62,17.89,6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.56,67.16c-.23.21-.47.42-.71.61.24-.2.48-.4.71-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.98,68.46c.3-.22.59-.45.87-.69-.28.25-.57.48-.87.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.73,67.16c4.33,3.9,10.4,6.3,17.41,6.3,6.2,0,11.66-1.88,15.84-5-4.22,3.22-9.67,5.13-15.84,5.13-6.97,0-13.01-2.44-17.41-6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.14,59.44c-6.69,0-13.18,2.5-18.17,7-3.96-3.89-6.29-9.12-6.29-14.87,0,0,9.55-3.87,24.46-3.87s24.47,3.87,24.47,3.87c0,5.75-2.33,10.98-6.3,14.88-4.99-4.52-11.48-7.01-18.17-7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.97,66.44c4.99-4.5,11.48-7,18.17-7s13.18,2.49,18.17,7.01c-.09.1-.19.19-.28.28-4.82-4.33-11.06-6.95-17.89-6.95s-13.06,2.62-17.88,6.95c-.1-.09-.19-.18-.29-.29Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.14,90.2c-19.88,0-36.05-16.17-36.05-36.06S34.26,18.09,54.14,18.09s36.06,16.17,36.06,36.05-16.17,36.06-36.06,36.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.66,66.76c-4.49,4.56-11.07,7.39-18.52,7.39s-14.03-2.83-18.52-7.39c-3.84-3.9-6.14-9.07-6.14-14.81,0-.5.3-.96.77-1.15.38-.15,9.53-3.78,23.89-3.78s23.52,3.63,23.9,3.78c.46.19.77.65.77,1.15,0,5.75-2.31,10.91-6.15,14.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.66,66.76c-.11-.11-.23-.21-.35-.31-4.99-4.52-11.48-7.01-18.17-7.01s-13.18,2.5-18.17,7c-.12.1-.23.21-.34.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.46,38.93c0-3.02,2.45-5.47,5.47-5.47s5.47,2.45,5.47,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.89,38.93c0-3.02,2.45-5.47,5.47-5.47s5.46,2.45,5.46,5.47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnyReactionIcon);
export default __webpack_public_path__ + "static/media/funny-reaction-icon.5d068cdd5937442602eb8ca9216e8b82.svg";
export { ForwardRef as ReactComponent };